import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  notFound: {
    height: 'fit-content',
    width: '100% !important',
    padding: '1.5rem 0',
    fontSize: '1.6rem',
    fontWeight: '600',
    color: '#CCC',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0 0 5px 5px',
    '& > span': {
      maxWidth: '50%',
      textAlign: 'justify',
      '@media (max-width: 500px)': {
        maxWidth: 'calc(100% - 2rem)',
      },
    },
    '@media (max-width: 600px)': {
      fontSize: '1.25rem',
    },
  },

  clippingEmpty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '16rem',
    marginBottom: '2rem',
    color: '#BBB',
  },
}))
